import type { FieldProps } from './TextField';
import { useFormField } from '../../hooks/useFormField';
import { QuestionWrapper } from '../QuestionWrapper';

export function ReadOnlyField({ fieldSchema, group }: FieldProps) {
  const field = useFormField(fieldSchema, group);

  if (!field.show) {
    return null;
  }

  return (
    <div>
      <hr className="pull-right" />
      <div className="stepform-question-wrapper" id={`field-${field.question.id}`}>
        <div className="question table">
          <legend id={`label-q-${field.question.id}`}>
            {field.question.label}{' '}
            {field.question.optional && <span className="optional">(optional)</span>}
          </legend>
          {fieldSchema.helpText && (
            <div className="help-toggle-wrapper">
              <button
                type="button"
                onClick={field.toggleQuestionHelpText}
                aria-controls={field.questionHelpTextId}
                aria-expanded={field.helpTextOpen}
              >
                ?<span className="visuallyhidden">Show/Hide supporting help text</span>
              </button>
            </div>
          )}
        </div>

        {fieldSchema.supportText && (
          <div
            className="qa-support-text"
            dangerouslySetInnerHTML={{ __html: fieldSchema.supportText }}
          />
        )}

        {fieldSchema.helpText && (
          <div
            className={`a-help qa-help-text pull-right ${field.helpTextExtraClass}${field.helpTextOpen ? ' open' : ''}`}
            id={field.questionHelpTextId}
            aria-hidden={!field.helpTextOpen && !fieldSchema.openHelpText}
          >
            <div className="outer">
              <div className="inner" dangerouslySetInnerHTML={{ __html: fieldSchema.helpText }} />
            </div>
          </div>
        )}

        <div className="answer-group">
          <div className="answer">
            <p>{String(field.answer ?? '')}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
